export default __webpack_public_path__ + "static/media/confusionImg_3.61e4c4d9.png";